/**
 * The one predicate that decides which app boots — see src/bootstrap.ts.
 *
 * `/schools` and anything under it is the schools checkout; every other
 * path is the existing onboarding app, untouched. Kept import-free so it
 * can be unit-tested under plain `node --test`
 * (types/schools-pricing/test.sh runs tests/bootstrap.test.ts too).
 */
export function isSchoolsPath(pathname: string): boolean {
  return /^\/schools(\/|$)/.test(pathname || "");
}
